export default __webpack_public_path__ + "static/media/spr-components-dark-large.1ba99861.png";